import {Component, Input, OnInit} from '@angular/core';
import {NewsService} from '@iw-shop/news/services/news.service';
import {DomSanitizer} from '@angular/platform-browser';
import {setReadNews} from '@store/actions/storage.action';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {EnvironmentService} from "@iw-shop/core//services/environment.service";
import {ApiNews} from "@api/news";

@Component({
    selector: 'iw-shop-news-template',
    standalone: false,
    templateUrl: './news-template.component.html',
    styleUrls: ['./news-template.component.scss']
})
export class NewsTemplateComponent implements OnInit {

    @Input() loadId?: string;
    @Input() markNewsAsRead: boolean = true;
    @Input() news?: ApiNews;

    resourceUrl?: any = null;

    constructor(private store: Store<AppState>, private newsService: NewsService, private sanitizer: DomSanitizer, private environmentService: EnvironmentService) {

    }

    ngOnInit(): void {

        this.resourceUrl = this.environmentService.environment.urlS3;
        if (this.loadId) {
            this.newsService.get({filters: [{fields: ['id'], values: [this.loadId]}], news: {limit: 1}}).subscribe(
                r => {
                    if (r.result) {
                        r.result.news.data.map(
                            news => {
                                this.news = news;
                                this.setReadNews();
                            }
                        )
                    }
                }
            )
        } else {
            this.setReadNews();
        }

    }

    setReadNews() {
        if (this.markNewsAsRead) {
            setTimeout(() => {
                this.store.dispatch(setReadNews({id: this.news?.id || ''}));
            }, 2000);
        }
    }

    safeHTML(unsafe: string) {
        return this.sanitizer.bypassSecurityTrustHtml(unsafe);
    }

}
